import React from "react";

interface IconProps {
  className?: string;
  strokeColor?: string;
  width?: number;
  height?: number;
}

function CaretRight({ width = 6, height = 10, className, strokeColor = "#2255F9" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 6 10"
      fill="none"
      className={className}
    >
      <path
        d="M0.46967 0.401311C0.735936 0.135044 1.1526 0.110838 1.44621 0.328692L1.53033 0.401311L5.53033 4.40131C5.7966 4.66758 5.8208 5.08424 5.60295 5.37785L5.53033 5.46197L1.53033 9.46197C1.23744 9.75486 0.762563 9.75486 0.46967 9.46197C0.203403 9.1957 0.179197 8.77904 0.397052 8.48543L0.46967 8.40131L3.939 4.93164L0.46967 1.46197C0.203403 1.1957 0.179197 0.77904 0.397052 0.485429L0.46967 0.401311Z"
        fill={strokeColor}
      />
    </svg>
  );
}

export {  CaretRight };
